export const FETCH_SUB_CATEGORY_REQUEST = "FETCH_SUB_CATEGORY_REQUEST";
export const FETCH_SUB_CATEGORY_SUCCESS = "FETCH_SUB_CATEGORY_SUCCESS";
export const FETCH_SUB_CATEGORY_FAIL = "FETCH_SUB_CATEGORY_FAIL";

export const UPDATE_SUB_CATEGORY_REQUEST = "UPDATE_SUB_CATEGORY_REQUEST";
export const UPDATE_SUB_CATEGORY_SUCCESS = "UPDATE_SUB_CATEGORY_SUCCESS";
export const UPDATE_SUB_CATEGORY_FAIL = "UPDATE_SUB_CATEGORY_FAIL";
















// export const ADD_SUB_CATEGORY_REQUEST = "ADD_SUB_CATEGORY_REQUEST";
// export const ADD_SUB_CATEGORY_SUCCESS = "ADD_SUB_CATEGORY_SUCCESS";
// export const ADD_SUB_CATEGORY_FAIL = "ADD_SUB_CATEGORY_FAIL";

// export const FETCH_SUB_CATEGORY_REQUEST = "FETCH_SUB_CATEGORY_REQUEST";
// export const FETCH_SUB_CATEGORY_SUCCESS = "FETCH_SUB_CATEGORY_SUCCESS";
// export const FETCH_SUB_CATEGORY_FAIL = "FETCH_SUB_CATEGORY_FAIL";